/* eslint-disable react/destructuring-assignment */
import React from 'react';
import styled from 'styled-components';
import WorkflowModalTooltip from '../components/tooltips/workflow-modal-tooltip';

function fetchFromObject(obj, prop) {
    if (!prop || !obj) {
        return false;
    }
    const index = prop.indexOf('.');
    if (index > -1) {
        const test = fetchFromObject(obj[prop.substring(0, index)], prop.substr(index + 1));
        return test;
    }
    return obj[prop];
}

interface ComponentWithTooltipProps {
    text?: string;
    right?: string;
}

const TooltipHover = (
    WrappedComponent, text, top, right, bottom, left, transition, path, transform = (x => x),
    limitCharactersNumber,
) => {
    const ComponentWithTooltip = (props: ComponentWithTooltipProps) => {
        const textCondition = props.text || text || fetchFromObject(props, path);
        return (
            <WrapperHover
                transition={transition}
            >
                {textCondition && (
                    <WorkflowModalTooltipStyled
                        bottom={bottom}
                        className="onHoverShowTooltip"
                        left={left}
                        limitCharactersNumber={limitCharactersNumber}
                        right={props.right || right}
                        text={transform(textCondition)}
                        top={top}
                    />
                )}
                <WrappedComponent {...props} />
            </WrapperHover>
        );
    };

    return ComponentWithTooltip;
};

const WorkflowModalTooltipStyled = styled(WorkflowModalTooltip)``;

export const WrapperHover = styled.div`
    position: relative;
        &:hover{
            .onHoverShowTooltip {
                opacity: 1;
                visibility: visible;
                transition: ${({ transition }) => transition || 'all 0.25s ease'};     
            }
        }
`;

TooltipHover.defaultProps = {
    transition: 'all 0.25s ease',
};

export default TooltipHover;
